<template>
	<view class="box">
		<view class="head" :style="{ height: 'calc(' + (navHeight + statusbarHeight + 'px + 264rpx)') }">
			<view class="head-bar" :style="{ height: navHeight + statusbarHeight + 'px' }">
				<view :style="{ width: '100%', height: statusbarHeight + 'px' }"></view>
				<view class="head-bar-nav" :style="{ height: navHeight + 'px' }">
					<image src="/static/icon/nav_ic_back@2x.png" mode="widthFix"></image>
					<text>订单详情</text>
					<image style="opacity: 0;" src="/static/icon/nav_ic_back@2x.png" mode="widthFix"></image>
				</view>
			</view>
			<view class="info">
				<view class="info-status">待支付</view>
				<view class="info-desc">
					剩余支付时间 08:32，请尽快付款哦，过期将自动取消~
				</view>
			</view>
			<view class="user">
				<view class="user-jxa">
					<view class="user-jxa-title">
						<image src="/static/icon/ic_address@2x1.png" mode="widthFix"></image>
						<text>XXXX经销商</text>
					</view>
					<view class="user-jxa-lx">
						<image src="/static/icon/ic_call@2x.png" mode="widthFix"></image>
						<text>联系商家</text>
					</view>
				</view>
				<view class="user-jxtime">
					<image class="user-jxtime-icon" src="/static/icon/ic_openinghours@2x.png" mode="widthFix"></image>
					<text>营业时间：周一至周五 09:00-19:00</text>
				</view>
				<view class="user-jxtime">
					<image class="user-jxtime-icon" src="/static/icon/ic_shopaddress@2x.png" mode="widthFix"></image>
					<text>安徽省合肥市经开区繁华大道200号</text>
					<image class="user-jxtime-to" src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
				</view>
				<view class="user-qrcode">
					<view class="user-qrcode-image">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view class="user-qrcode-code">767889</view>
					<view class="user-qrcode-btn">复制自提码</view>
				</view>
			</view>
			<!-- <view class="user">
				<view class="user-top">
					<view class="user-icon">
						<image src="/static/icon/ic_location@2x.png" mode="widthFix"></image>
					</view>
					<view class="user-info">
						<view class="user-info-a">
							<text>李金平</text>
							<text>181777889338</text>
						</view>
						<view class="user-info-b">
							安徽省合肥市经开区松谷路凤凰国际B座808 豆米科技有限公司
						</view>
					</view>
				</view>
				<view class="user-xian"></view>
				<view class="user-kd">
					<image src="/static/icon/ic_wuliu@2x.png" mode="widthFix"></image>
					<text>顺丰速运｜SF1923218478129473</text>
				</view>
			</view> -->
			<view class="shop">
				<view class="shop-info" style="margin: 0;">
					<view class="shop-info-item" style="margin-bottom: 12rpx;">
						<view class="shop-info-item-label" style="color: #222222; font-size: 30rpx; font-weight: 600;">退款金额</view>
						<view class="shop-info-item-price xfk">
							<text>998</text>
							<text>.00</text>
						</view>
					</view>
					<view class="shop-info-item" style="margin-bottom: 12rpx;">
						<view class="shop-info-item-label" style="color: #999999; font-size: 24rpx; font-weight: 400;">已退回您的支付账户</view>
						<view class="shop-info-item-price" style="color: #999999; font-size: 24rpx; font-weight: 400;">
							2025-06-12 09:20:20
						</view>
					</view>
					<view class="shop-info-item">
						<view class="shop-info-item-label" style="color: #999999; font-size: 24rpx; font-weight: 400;">退款备注</view>
						<view class="shop-info-item-price" style="color: #999999; font-size: 24rpx; font-weight: 400;">
							协商一致退款
						</view>
					</view>
				</view>
			</view>
			<view class="shop">
				<view class="shop-top">
					<view class="shop-top-tips">配送</view>
					<text>合肥鼎元旋压科技有限公司</text>
				</view>
				<view class="b">
					<view class="b-item" v-for="(item, index) in 2" :key="index">
						<view class="b-item-image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="b-item-title">
							<view class="b-item-title-val">中联艾禾宽齿 适用雷沃/中联/久保田</view>
							<view class="b-item-jia">
								<text>¥499.00</text>
								<text>x1</text>
							</view>
						</view>
					</view>
				</view>
				<view class="shop-info">
					<view class="shop-info-item">
						<view class="shop-info-item-label">商品总价</view>
						<view class="shop-info-item-price">
							<text>998</text>
							<text>.00</text>
						</view>
					</view>
					<view class="shop-info-item">
						<view class="shop-info-item-label">运费</view>
						<view class="shop-info-item-price yf">
							<text>10</text>
							<text>.00</text>
						</view>
					</view>
					<view class="shop-info-item">
						<view class="shop-info-item-label">优惠券</view>
						<view class="shop-info-item-price yhj">
							<text>998</text>
							<text>.00</text>
						</view>
					</view>
					<view class="shop-info-item">
						<view class="shop-info-item-label">积分抵扣</view>
						<view class="shop-info-item-price yhj">
							<text>10</text>
							<text>.00</text>
						</view>
					</view>
					<view class="shop-info-item">
						<view class="shop-info-item-label" style="color: #222222; font-size: 30rpx; font-weight: 600;">需付款</view>
						<view class="shop-info-item-price xfk">
							<text>998</text>
							<text>.00</text>
						</view>
					</view>
				</view>
			</view>
			<view class="xinxi">
				<view class="xinxi-label">订单信息</view>
				<view class="xinxi-list">
					<view class="xinxi-list-item">
						<view class="xinxi-list-item-label">订单编号：</view>
						<view class="xinxi-list-item-right">
							<text>202107131742520001</text>
							<image src="/static/icon/ic_cppy@2x.png" mode="widthFix"></image>
						</view>
					</view>
					<view class="xinxi-list-item">
						<view class="xinxi-list-item-label">创建时间：</view>
						<view class="xinxi-list-item-right">
							<text>2025-08-12 12:00:00</text>
						</view>
					</view>
					<view class="xinxi-list-item">
						<view class="xinxi-list-item-label">订单备注：</view>
						<view class="xinxi-list-item-right">
							<text>-</text>
						</view>
					</view>
				</view>
			</view>
			<view style="width: 100%; height: calc(100rpx + env(safe-area-inset-bottom));"></view>
		</view>
		<view class="footer">
			<view class="caozuo">
				<view class="caozuo-item">取消订单</view>
				<view class="caozuo-item" style="border: 1rpx solid #004096; color: #004096;">继续支付</view>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
		<!-- 确认收货 -->
		<u-popup :show="show" round="15" :safeAreaInsetBottom="false" mode="center">
			<view class="tc">
				<view class="tc-contemt">
					<view class="tc-contemt-title">确认收货提醒</view>
					<view class="tc-contemt-nr">
						您确认已经收到商品了吗？
					</view>
				</view>
				<view class="tc-btn">
					<view class="tc-btn-item" @click="show = false">取消</view>
					<view class="tc-btn-item" style="color: #004096;">确认收货</view>
				</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight'])
		},
		data() {
			return {
				show: false
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.tc {
			width: calc(100vw - 148rpx);
			.tc-btn {
				width: 100%;
				height: 102rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-top: 1rpx solid #EEEEEE;
				.tc-btn-item {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: 32rpx;
					color: #666666;
					border-right: 1rpx solid #EEEEEE;
					&:last-child {
						border: none !important;
					}
				}
			}
			.tc-contemt {
				width: 100%;
				padding: 40rpx 0;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.tc-contemt-title {
					width: 100%;
					text-align: center;
					font-weight: 600;
					font-size: 32rpx;
					color: #111111;
				}
				.tc-contemt-nr {
					width: 472rpx;
					text-align: center;
					font-weight: 400;
					font-size: 28rpx;
					color: #333333;
					margin-top: 40rpx;
				}
			}
		}
		.footer {
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 999;
			width: 100%;
			box-shadow: 0rpx -1rpx 0rpx 0rpx #EEEEEE;
			background-color: #fff;
			height: calc(100rpx + env(safe-area-inset-bottom));
			.caozuo {
				width: 100%;
				height: 100rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.caozuo-item {
					padding: 0 24rpx;
					box-sizing: border-box;
					height: 64rpx;
					border-radius: 32rpx;
					border: 1rpx solid #B2B2B2;
					font-weight: 400;
					font-size: 28rpx;
					display: flex;
					align-items: center;
					color: #666666;
					margin-right: 20rpx;
					&:last-child {
						margin: 0 !important;
					}
				}
			}
		}
		.head {
			width: 100%;
			height: 424rpx;
			padding: 0 30rpx;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			box-sizing: border-box;
			background: #004096;
		
			.head-bar {
				width: 100%;
		
				.head-bar-nav {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					
					image {
						width: 48rpx;
						height: 48rpx;
					}
					
					text {
						font-weight: 500;
						font-size: 32rpx;
						color: #FFFFFF;
					}
				}
			}
			.info {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 22rpx;
				.info-status {
					font-weight: 600;
					font-size: 36rpx;
					color: #FFFFFF;
				}
				.info-desc {
					font-weight: 400;
					font-size: 26rpx;
					color: #FFFFFF;
					margin-top: 12rpx;
				}
			}
			.xinxi {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 20rpx;
				.xinxi-label {
					font-weight: 600;
					font-size: 30rpx;
					color: #222222;
					margin-bottom: 18rpx;
				}
				.xinxi-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					.xinxi-list-item {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.xinxi-list-item-label {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
						.xinxi-list-item-right {
							display: flex;
							align-items: center;
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #999999;
							}
							image {
								width: 24rpx;
								height: 24rpx;
								margin-left: 16rpx;
							}
						}
					}
				}
			}
			.shop {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 20rpx;
				.shop-top {
					width: 100%;
					display: flex;
					align-items: center;
					.shop-top-tips {
						width: 60rpx;
						height: 40rpx;
						line-height: 40rpx;
						text-align: center;
						font-weight: 400;
						font-size: 22rpx;
						color: #FFFFFF;
						background: #004096;
						border-radius: 8rpx;
						border: 1rpx solid #004096;
						margin-right: 16rpx;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #222222;
					}
				}
				.b {
					width: 100%;
					display: flex;
					flex-direction: column;
					margin-top: 30rpx;
					.b-item {
						width: 100%;
						height: 136rpx;
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						margin-bottom: 24rpx;
						&:last-child {
							margin: 0 !important;
						}
						.b-item-image {
							flex-shrink: 0;
							width: 136rpx;
							height: 136rpx;
							border-radius: 8rpx;
							overflow: hidden;
							border: 1rpx solid #E5E5E5;
							margin-right: 20rpx;
							image {
								width: 100%;
							}
						}
						.b-item-title {
							flex: 1;
							height: 136rpx;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.b-item-title-val {
								width: 100%;
								font-weight: 400;
								font-size: 30rpx;
								color: #222222;
							}
							.b-item-jia {
								flex-shrink: 0;
								display: flex;
								align-items: center;
								justify-content: space-between;
								text {
									&:nth-child(1) {
										font-weight: 500;
										font-size: 30rpx;
										color: #222222;
									}
									&:nth-child(2) {
										font-weight: 400;
										font-size: 24rpx;
										color: #999999;
									}
								}
							}
						}
						
					}
				}
				.shop-info {
					width: 100%;
					margin-top: 30rpx;
					.shop-info-item {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 24rpx;
						&:last-child {
							margin: 0 !important;
						}
						.shop-info-item-label {
							font-weight: 400;
							font-size: 28rpx;
							color: #333333;
						}
						.xfk {
							text {
								&:nth-child(1) {
									font-weight: 500 !important;
									font-size: 36rpx !important;
									color: #E4001D !important;
									&::before {
										content: '￥' !important;
										font-weight: 500 !important;
										font-size: 24rpx !important;
										color: #E4001D !important;
									}
								}
								&:nth-child(2) {
									font-weight: 500 !important;
									font-size: 24rpx !important;
									color: #E4001D !important;
								}
							}
						}
						.yhj {
							text {
								&:nth-child(1) {
									font-weight: 500 !important;
									font-size: 28rpx !important;
									color: #E4001D !important;
									&::before {
										content: '-￥' !important;
										font-weight: 500 !important;
										font-size: 24rpx !important;
										color: #E4001D !important;
									}
								}
								&:nth-child(2) {
									font-weight: 500 !important;
									font-size: 24rpx !important;
									color: #E4001D !important;
								}
							}
						}
						.yf {
							text {
								&:nth-child(1) {
									font-weight: 500 !important;
									font-size: 28rpx !important;
									color: #222222 !important;
									&::before {
										content: '￥';
										font-weight: 500 !important;
										font-size: 24rpx !important;
										color: #222222 !important;
									}
								}
								&:nth-child(2) {
									font-weight: 500 !important;
									font-size: 24rpx !important;
									color: #222222 !important;
								}
							}
						}
						.shop-info-item-price {
							display: flex;
							align-items: baseline;
							text {
								&:nth-child(1) {
									font-weight: 500;
									font-size: 30rpx;
									color: #222222;
									&::before {
										content: '￥';
										font-weight: 500;
										font-size: 24rpx;
										color: #222222;
									}
								}
								&:nth-child(2) {
									font-weight: 500;
									font-size: 24rpx;
									color: #222222;
								}
							}
						}
					}
				}
			}
			.user {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 40rpx;
				.user-jxa {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.user-jxa-title {
						display: flex;
						align-items: center;
						image {
							width: 48rpx;
							height: 48rpx;
							margin-right: 20rpx;
						}
						text {
							font-weight: 500;
							font-size: 30rpx;
							color: #222222;
						}
					}
					.user-jxa-lx {
						display: flex;
						align-items: center;
						image {
							width: 26rpx;
							height: 26rpx;
							margin-right: 10rpx;
						}
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
						}
					}
				}
				.user-jxtime {
					width: 100%;
					display: flex;
					align-items: center;
					margin-top: 12rpx;
					.user-jxtime-icon {
						width: 26rpx;
						height: 26rpx;
						margin-right: 10rpx;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #222222;
					}
					.user-jxtime-to {
						width: 10rpx;
						height: 20rpx;
						margin-left: 10rpx;
					}
				}
				.user-qrcode {
					width: 100%;
					margin-top: 50rpx;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.user-qrcode-image {
						width: 360rpx;
						height: 360rpx;
						padding: 10rpx;
						box-sizing: border-box;
						border-radius: 8rpx;
						border: 2rpx solid #EEEEEE;
						image {
							width: 100%;
							height: 100%;
						}
					}
					.user-qrcode-code {
						font-weight: 600;
						font-size: 36rpx;
						color: #222222;
						margin-top: 32rpx;
					}
					.user-qrcode-btn {
						font-weight: 400;
						font-size: 26rpx;
						color: #999999;
						margin-top: 12rpx;
					}
				}
				.user-top {
					display: flex;
					align-items: flex-start;
					.user-icon {
						flex-shrink: 0;
						width: 48rpx;
						height: 48rpx;
						margin-right: 22rpx;
						image {
							width: 100%;
						}
					}
					.user-info {
						flex: 1;
						display: flex;
						flex-direction: column;
						.user-info-a {
							width: 100%;
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-weight: 500;
									font-size: 30rpx;
									color: #222222;
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 26rpx;
									color: #666666;
									margin-left: 14rpx;
								}
							}
						}
						.user-info-b {
							width: 100%;
							font-weight: 400;
							font-size: 26rpx;
							color: #666666;
							margin-top: 18rpx;
						}
					}
				}
				.user-xian {
					width: 100%;
					height: 1rpx;
					margin: 30rpx 0;
					background-color: #E5E5E5;
				}
				.user-kd {
					width: 100%;
					display: flex;
					align-items: center;
					image {
						width: 30rpx;
						height: 30rpx;
						margin-right: 12rpx;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #333333;
					}
				}
			}
		}
	}
</style>